import { Box, Typography } from "@mui/material";
import React from "react";
import OTPInput from "react-otp-input";

export default function CustomOtpInput(props) {
  return (
    <>
      <OTPInput
        className="custom-otp-input"
        // renderSeparator={<Box className="custom-otp-input-spacer" />}
        inputStyle={{
          width: "56px",
          height: "56px",
          borderRadius: "4px",
          border: "1px solid #FFF",
          background: "#FFF",
          fontSize: "24px",
          color: "initial",
        }}
        // renderInput={(props) => <input {...props} />}
        renderInput={(inputProps) => (
          <input
            {...inputProps}
            type="number"
            className="otp_input text-black"
          />
        )}
        {...props}
      />
      {Boolean(props.error) ? (
        <Box pt={2}>
          <Typography
            style={{ color: "#FF7070", fontSize: "16px", paddingRight: "4px" }}
          >
            {props.error}
          </Typography>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
}
